import * as React from "react";
var MANAGEMENT_TYPES = [{
  value: "cotizacion",
  label: "Cotización enviada"
}, {
  value: "seguimiento",
  label: "Seguimiento comercial"
}, {
  value: "renovacion",
  label: "Renovación cerrada"
}, {
  value: "siniestro",
  label: "Siniestro"
}, {
  value: "otro",
  label: "Otro"
}];
var CONTACT_METHODS = [{
  value: "email",
  label: "Email"
}, {
  value: "telefono",
  label: "Teléfono"
}, {
  value: "whatsapp",
  label: "WhatsApp"
}, {
  value: "reunion",
  label: "Reunión"
}, {
  value: "presencial",
  label: "Presencial"
}];
var STATUS_OPTIONS = [{
  value: "pendiente",
  label: "Pendiente"
}, {
  value: "en_proceso",
  label: "En proceso"
}, {
  value: "cerrado",
  label: "Cerrado"
}];

var CommentForm = function CommentForm(props) {
  var onSubmit = props.onSubmit,
      _props$initialData = props.initialData,
      initialData = _props$initialData === void 0 ? {} : _props$initialData,
      onCancel = props.onCancel;
  var textareaRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var managementTypeRef = React.useRef(null);
  var contactMethodRef = React.useRef(null);
  var statusRef = React.useRef(null);
  React.useEffect(function () {
    if (textareaRef.current && initialData.content) {
      textareaRef.current.value = initialData.content;
    }

    if (inputRef.current && initialData.next_step) {
      inputRef.current.value = initialData.next_step;
    }

    if (managementTypeRef.current && initialData.management_type) {
      managementTypeRef.current.value = initialData.management_type;
    }

    if (contactMethodRef.current && initialData.contact_method) {
      contactMethodRef.current.value = initialData.contact_method;
    }

    if (statusRef.current && initialData.status) {
      statusRef.current.value = initialData.status;
    }
  }, [initialData]);

  var handleSubmit = function handleSubmit(e) {
    var _textareaRef$current;

    e.preventDefault();
    var content = ((_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 ? void 0 : _textareaRef$current.value) || "";

    if (content.trim()) {
      var _managementTypeRef$cu, _contactMethodRef$cur, _inputRef$current, _inputRef$current$val, _statusRef$current;

      onSubmit({
        content: content.trim(),
        management_type: ((_managementTypeRef$cu = managementTypeRef.current) === null || _managementTypeRef$cu === void 0 ? void 0 : _managementTypeRef$cu.value) || undefined,
        contact_method: ((_contactMethodRef$cur = contactMethodRef.current) === null || _contactMethodRef$cur === void 0 ? void 0 : _contactMethodRef$cur.value) || undefined,
        next_step: ((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$val = _inputRef$current.value) === null || _inputRef$current$val === void 0 ? void 0 : _inputRef$current$val.trim()) || undefined,
        status: ((_statusRef$current = statusRef.current) === null || _statusRef$current === void 0 ? void 0 : _statusRef$current.value) || undefined
      });
      if (textareaRef.current) textareaRef.current.value = "";
      if (inputRef.current) inputRef.current.value = "";
      if (managementTypeRef.current) managementTypeRef.current.value = "";
      if (contactMethodRef.current) contactMethodRef.current.value = "";
      if (statusRef.current) statusRef.current.value = "";
    }
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "comment-form-compact",
    style: {
      display: "flex",
      flexDirection: "column",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Escribe tu comentario..."), /*#__PURE__*/React.createElement("textarea", {
    ref: textareaRef,
    className: "form-control",
    rows: 3,
    placeholder: "Escribe tu comentario...",
    style: {
      fontSize: "13px",
      resize: "vertical"
    },
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Tipo de Gesti\xF3n"), /*#__PURE__*/React.createElement("select", {
    ref: managementTypeRef,
    className: "form-control",
    style: {
      fontSize: "13px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un tipo"), MANAGEMENT_TYPES.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Medio de Contacto"), /*#__PURE__*/React.createElement("select", {
    ref: contactMethodRef,
    className: "form-control",
    style: {
      fontSize: "13px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un medio"), CONTACT_METHODS.map(function (method) {
    return /*#__PURE__*/React.createElement("option", {
      key: method.value,
      value: method.value
    }, method.label);
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Pr\xF3ximo Paso"), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "text",
    className: "form-control",
    placeholder: "Ej: Esperar respuesta del cliente",
    style: {
      fontSize: "13px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Estado"), /*#__PURE__*/React.createElement("select", {
    ref: statusRef,
    className: "form-control",
    style: {
      fontSize: "13px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un estado"), STATUS_OPTIONS.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      gap: "8px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "10px"
    }
  }, onCancel && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: onCancel
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-sm"
  }, "Guardar")));
};

export default CommentForm;